import FieldSet from '../../FieldSet';

import { CompletedDate } from './CompletedDate';

export class CompletedDateFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [CompletedDate];
  }

  get title() {
    return 'Completed date';
  }
}
